import { reqLogin, GetUserInfo, GetPhoneCode, PutPassword, PutUserInfo } from '@/api/user'
import { setToken, getToken, removeToken } from '@/utils/cookie.js'
export default {
  namespaced: true,
  state: {
    token: getToken() || '',
    userInfo: {} // 用户信息
  },
  mutations: {
    // 存储token的mutation
    setToken(state, token) {
      // 将token存储到vuex中
      state.token = token
      // 将token存储到cookie中持久化
      setToken(token)
    },
    // 设置个人信息的mutation
    setUserInfo(state, info) {
      state.userInfo = info
    },
    // 移除token
    removeToken(state) {
      state.token = '' // vuex中清除
      removeToken() // 本地清除
    },
    // 移除个人信息
    removeUserInfo(state) {
      state.userInfo = {}
    }
  },
  actions: {
    // 登录
    async  login({ commit }, loginForm) {
      const res = await reqLogin(loginForm)
      commit('setToken', res.token)
      return res
    },
    // 获取用户信息
    async getUserInfo({ commit }) {
      const res = await GetUserInfo()
      // console.log(res)
      commit('setUserInfo', res.user_info)
    },
    // 获取手机验证码
    async getCode({ commit }, item) {
      const res = await GetPhoneCode(item)
      return res
    },
    // 重置密码
    async putPassword({ commit }, item) {
      await PutPassword(item)
    },
    // 修改用户的姓名和密码
    async putUserInfo({ commit }, item) {
      await PutUserInfo(item)
    },
    // 退出登录
    logout({ commit }) {
      // 移除token
      commit('removeToken')
      // 移除用户信息
      commit('removeUserInfo')
      Object.keys(localStorage).forEach(function(key) {
        localStorage.removeItem(key)
      })
      Object.keys(sessionStorage).forEach(function(key) {
        sessionStorage.removeItem(key)
      })
    }
  }
}
